module.exports = __webpack_public_path__ + "static/media/U1.857cdb1a.jpg";